<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />

    <div class="mb-2">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <router-link to="/prestador">Prestador</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ datoPrestador.razonSocial || p_idPrestador }}
          </li>
        </ol>
      </nav>
    </div>
    <hr />

    <div class="card mb-4 shadow-sm">
      <div class="card-body">
        <form>
          <div class="row mb-3">
            <div class="col-md-2"><label class="form-label fw-bold">Razón Social</label></div>
            <div class="col-md-7">
              <input type="text" class="form-control-plaintext" :value="datoPrestador.razonSocial" readonly style="text-transform: uppercase" />
            </div>
            <div class="col-md-1"><label class="form-label fw-bold">ID</label></div>
            <div class="col-md-2">
              <input type="text" class="form-control-plaintext" :value="datoPrestador.idPrestador" readonly />
            </div>
          </div>

          <div class="row">
            <div class="col-md-2"><label class="form-label fw-bold">Nombre Comercial</label></div>
            <div class="col-md-7">
              <input type="text" class="form-control-plaintext" :value="datoPrestador.nombreComercial" readonly style="text-transform: uppercase" />
            </div>
            <div class="col-md-1"><label class="form-label fw-bold">RUC</label></div>
            <div class="col-md-2">
              <input type="text" class="form-control-plaintext" :value="datoPrestador.ruc" readonly />
            </div>
          </div>
        </form>
      </div>
    </div>

    <h5 class="mb-3">
      <span class="material-icons align-middle me-1" style="font-size:20px">list_alt</span>
      Elementos Asociados
    </h5>

    <DataTable
      :data="elempress"
      :columns="columnasDet"
      idField="idElemPres"
      mensajeVacio="No hay elementos configurados para este prestador."
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="true"
      :mostrarEliminar="false"
      @refresh="getDataTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idElemPres)"
      @view="row => abrirEditarDet(row.idElemPres)"
      @delete="row => deleteElemPres(row.idElemPres)"
    >
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar por nombre..."
            style="width:250px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button class="btn btn-outline-primary btn-sm" @click="getDataNombre">
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>
    </DataTable>

    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">
              <span class="material-icons align-middle me-1">add_circle</span> {{ titulo }}
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3" v-if="btnEditar_det">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">ID</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoElemPres.idElemPres" disabled />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Código</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoElemPres.codigo" style="text-transform:uppercase" required />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Nombre</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoElemPres.nombre" style="text-transform:uppercase" required />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click.prevent="guardarElemPres" v-if="btnCrear_det">
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span> Guardar
            </button>
            <button type="button" class="btn btn-warning" @click.prevent="guardarEditElemPres" v-if="btnEditar_det">
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span> Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import DataTable from "@/components/DataTable.vue";
import api from "@/services/api";
import Swal from "sweetalert2";
import * as $ from "jquery";

export default {
  name: "PrestadorElementosForm",
  components: { Layout, Footer, DataTable },
  data() {
    return {
      p_idPrestador: "",
      datoPrestador: {},
      
      elempress: [],
      datoElemPres: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear_det: false,
      btnEditar_det: false,
      modalWindow: true,
    };
  },
  computed: {
    columnasDet() {
      return [
        { label: "Código", field: "codigo" },
        { label: "Nombre del Elemento", field: "nombre" },
      ];
    },
  },
  mounted() {
    this.p_idPrestador = this.$route.params.p_idprestador;
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    
    this.cargarMaster();
    this.getDataTodos();
  },
  methods: {
    // ── Master ────────────────────────────────────────────────
    async cargarMaster() {
      try {
        const resp = await api.get("/vwprestadors/" + this.p_idPrestador);
        this.datoPrestador = resp.data;
      } catch (e) {
        console.error("Error al cargar prestador:", e);
      }
    },

    // ── Detail — Datos ────────────────────────────────────────
    async getDataTodos() {
      this.nombreBusqueda = "";
      try {
        const r = await api.get("/vwelempress/idprestador/" + this.p_idPrestador);
        this.elempress = Array.isArray(r.data) ? r.data : [];
      } catch (e) {
        console.error("Error al cargar elementos:", e);
      }
    },

    async getDataNombre() {
      const nombre = this.nombreBusqueda.trim();
      if (!nombre) { this.getDataTodos(); return; }
      try {
        const r = await api.get("/vwelempress/nombre/" + nombre);
        // Filtrar localmente por prestador si el endpoint devuelve global
        this.elempress = r.data.filter(i => i.idPrestador == this.p_idPrestador);
      } catch (e) {
        console.error("Error al buscar:", e);
      }
    },

    // ── Detail — CRUD ─────────────────────────────────────────
    async guardarElemPres() {
      try {
        this.datoElemPres.idPrestador = this.p_idPrestador;
        await api.post("/elempress", this.datoElemPres);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Elemento creado exitosamente." });
        this.getDataTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo guardar el registro." });
      }
    },

    async guardarEditElemPres() {
      try {
        await api.post("/elempress", this.datoElemPres);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Elemento actualizado exitosamente." });
        this.getDataTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo actualizar." });
      }
    },

    async deleteElemPres(id) {
      const confirm = await Swal.fire({
        title: "¿Eliminar elemento?",
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar"
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/elempress/" + id);
        this.getDataTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Detail — Modales/Navegación ───────────────────────────
    abrirModalCrear() {
      this.datoElemPres = { idPrestador: this.p_idPrestador };
      this.titulo = "Crear Elemento";
      this.btnCrear_det = true;
      this.btnEditar_det = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(id) {
      this.titulo = "Editar Elemento";
      this.btnCrear_det = false;
      this.btnEditar_det = true;
      try {
        const resp = await api.get("/vwelempress/" + id);
        this.datoElemPres = resp.data;
        this.$nextTick(() => $("#ventanaModal").modal("show"));
      } catch (e) {
        console.error("Error al cargar detalle:", e);
      }
    },

    abrirEditarDet(id) {
      this.$router.push("/elempres_elemequi/" + id);
    }
  }
};
</script>